import { Component, OnInit } from '@angular/core';
import { Data } from '../../comum/data/data';
import { ResultadoInconsistencia } from '../../comum/modelos/resultado-inconsistencia';
import { ColetaService } from '../coleta.service';
import { FiltroInconsistencia } from '../../comum/modelos/filtro-inconsistencia';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Paginacao } from '../../comum/modelos/paginacao';

@Component({
    selector: 'app-resultado-inconsistencias',
    templateUrl: './resultado-inconsistencias.component.html',
    styleUrls: ['./resultado-inconsistencias.component.css']
})
export class ResultadoInconsistenciasComponent implements OnInit {

    totalVisitas: ResultadoInconsistencia[];
    totalInconsistencias: ResultadoInconsistencia[];
    filtroInconsistencia: FiltroInconsistencia;

    public paginacaoVisitas: Paginacao;
    public paginacaoInconsistencias: Paginacao;

    public loading = false;

    constructor (
        private _coletaService: ColetaService,
        private data: Data) {
        this.totalVisitas = new Array<ResultadoInconsistencia>();
        this.totalInconsistencias = new Array<ResultadoInconsistencia>();
        this.filtroInconsistencia = new FiltroInconsistencia();
        this.paginacaoVisitas = new Paginacao();
        this.paginacaoInconsistencias = new Paginacao();
    }

    ngOnInit() {
        this.loading = true;
        const self = this;
        this.filtroInconsistencia = this.data.storage.filtroInconsistencia;
        this.paginacaoVisitas.itens = 5;
        this.paginacaoVisitas.page = 1;
        this.paginacaoVisitas.id = 'visitas';
        this.paginacaoInconsistencias.itens = 5;
        this.paginacaoInconsistencias.page = 1;
        this.paginacaoInconsistencias.id = 'inconsistencias';

        forkJoin(this._coletaService.obterTotalVisitasHttp(this.filtroInconsistencia),
            this._coletaService.obterTotalInconsistenciasHttp(this.filtroInconsistencia))
            .subscribe(([visitas, inconsistencias]) => {
                self.totalVisitas = visitas.body;
                self.totalInconsistencias = inconsistencias.body;
                self.totalInconsistencias.forEach(inconsistencia => {
                    inconsistencia.dataInicioReferencia = self.filtroInconsistencia.dataInicioReferencia;
                    inconsistencia.dataFimReferencia = self.filtroInconsistencia.dataFimReferencia;
                });
                self.loading = false;
            });
    }

    onSelect(event) {
        console.log(event);
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/resultado-inconsistencias/resultado-inconsistencias.component.ts